/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:48 GMT
 *
 */


const theme = {
  appearances: {
    focus: {
      description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    pressed: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    },
    viewport: {
      description: 'The size label for the current screen viewport based on the current screen width',
      type: 'state',
      values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
    }
  },
  rules: [
    {
      if: { viewport: 'xl' },
      tokens: { contentMaxDimension: 184, imageDimension: 168 }
    },
    {
      if: { focus: true },
      tokens: { outerBorderColor: '#2b8000', textLine: 'none' }
    },
    {
      if: { hover: true },
      tokens: { color: '#2b8000', imageDimension: 140, textLine: 'underline' }
    },
    {
      if: { hover: true, viewport: 'xl' },
      tokens: { imageDimension: 184 }
    },
    {
      if: { pressed: true },
      tokens: { color: '#1f5c09', textLine: 'none' }
    },
    {
      if: { focus: true, pressed: true },
      tokens: { color: '#1f5c09', outerBorderColor: '#1f5c09' }
    }
  ],
  tokens: {
    color: '#2c2e30',
    contentAlignItems: 'center',
    contentDirection: 'column',
    contentMaxDimension: 168,
    contentSpace: 3,
    fontName: 'HNforTELUSSA',
    fontSize: 16,
    fontWeight: '700',
    gap: 5,
    imageDimension: 128,
    outerBorderColor: 'rgba(0, 0, 0, 0)',
    textAlign: 'center',
    textLine: 'none'
  }
}
export default theme
